import React from "react";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4">
      <p className="text-8xl mb-6">👗</p>
      <h1 className="text-4xl font-bold text-gray-900 mb-3">404 – Page Not Found</h1>
      <p className="text-gray-500 mb-8">Looks like this page got lost in the wardrobe!</p>
      <Link to="/" className="btn-primary py-3 px-8">Go Home</Link>
    </div>
  );
}
